import { render, staticRenderFns } from "./TheProductCustomizerComplementSelector.vue?vue&type=template&id=865f47b6&"
import script from "./TheProductCustomizerComplementSelector.vue?vue&type=script&lang=js&"
export * from "./TheProductCustomizerComplementSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../sfra-webpack-builder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/sfra-webpack-builder/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('865f47b6')) {
      api.createRecord('865f47b6', component.options)
    } else {
      api.reload('865f47b6', component.options)
    }
    module.hot.accept("./TheProductCustomizerComplementSelector.vue?vue&type=template&id=865f47b6&", function () {
      api.rerender('865f47b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app_byl_core/cartridges/app_byl_core/cartridge/client/default/js/vue/components/customizer/TheProductCustomizerComplementSelector.vue"
export default component.exports